export default {"src":"/_next/static/media/emptySupport.8d866224.svg","height":202,"width":275,"blurWidth":0,"blurHeight":0};